import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import * as dataLayer from '@classic/Foundation/Analytics/AnalyticsDataLayer'

export type PrecommitmentEvent = {
  interaction_type:
    | 'Remove Bet Limit'
    | 'Edit Bet Limit'
    | 'Block Debit Card'
    | 'Unblock Debit Card'
    | 'Cancel Unblock Debit Card'
    | 'Need Assistance'
  limitAmount: string | undefined
  location: 'Bet Limits' | undefined
  depositFrequency: undefined
}

const defaultPrecommitmentValues: Omit<PrecommitmentEvent, 'interaction_type'> = {
  depositFrequency: undefined,
  limitAmount: undefined,
  location: undefined,
}

export const precommitmentTracker = (event: PrecommitmentEvent) =>
  trackEvent(dataLayer.keys.accountManagement, event)

export const trackRemoveBetLimit = () =>
  precommitmentTracker({
    interaction_type: 'Remove Bet Limit',
    ...defaultPrecommitmentValues,
  })

export const trackEditBetLimit = (limitAmount: string) =>
  precommitmentTracker({
    interaction_type: 'Edit Bet Limit',
    ...defaultPrecommitmentValues,
    limitAmount,
  })

export const trackBlockDebitCard = () =>
  precommitmentTracker({
    interaction_type: 'Block Debit Card',
    ...defaultPrecommitmentValues,
  })

export const trackUnblockDebitCard = () =>
  precommitmentTracker({
    interaction_type: 'Unblock Debit Card',
    ...defaultPrecommitmentValues,
  })

export const trackCancelUnblockDebitCard = () =>
  precommitmentTracker({
    interaction_type: 'Cancel Unblock Debit Card',
    ...defaultPrecommitmentValues,
  })

export const trackNeedAssistance = () =>
  precommitmentTracker({
    interaction_type: 'Need Assistance',
    ...defaultPrecommitmentValues,
    location: 'Bet Limits',
  })
